// Lightweight WebAudio chat sounds — no asset files, respects a mute flag in localStorage.
let ctx;

function play(freq, { duration = 0.09, type = "sine", gain = 0.05, ramp = 0 } = {}) {
  try {
    if (localStorage.getItem("iyeneh_sound") === "off") return;
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    const t = ctx.currentTime;
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = type;
    o.frequency.setValueAtTime(freq, t);
    if (ramp) o.frequency.exponentialRampToValueAtTime(ramp, t + duration);
    g.gain.setValueAtTime(gain, t);
    g.gain.exponentialRampToValueAtTime(0.0001, t + duration);
    o.connect(g);
    g.connect(ctx.destination);
    o.start(t);
    o.stop(t + duration);
  } catch (e) {
    /* audio unsupported — silently ignore */
  }
}

// Outgoing message: short soft upward blip.
export const playSend = () => play(620, { duration: 0.07, gain: 0.045, ramp: 720 });
// Incoming message: gentle two-note chime.
export const playReceive = () => {
  play(880, { duration: 0.1, gain: 0.05 });
  setTimeout(() => play(1175, { duration: 0.12, gain: 0.04 }), 90);
};

export const soundEnabled = () => localStorage.getItem("iyeneh_sound") !== "off";
export const setSoundEnabled = (on) => localStorage.setItem("iyeneh_sound", on ? "on" : "off");
